import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

import successSrc from '../../assets/check.svg';
import { Button } from '../../../UI/Button';

const DelegateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  margin: 20px auto 0;
  max-width: 400px;
  height: 100%;
`;

const Header = styled.h4`
  margin: 0 0 20px;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1.68px;
  text-transform: uppercase;
  color: ${props => props.theme.text2};
`;

const SuccessIconWrapper = styled.div`
  display: flex;
  justify-content: center;

  width: 145px;
  height: 145px;

  border-radius: 50%;
  border: 27px solid #dce7f8;
  background-color: ${props => props.theme.accent0};
`;

const Caption = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.05;
  text-align: center;
  color: ${props => props.theme.text0};
`;

const TextWrapper = styled.div`
  padding: 0 0 70px;

  font-size: 14px;
  font-weight: 500;
  line-height: 1.57;
  text-align: center;
  color: ${props => props.theme.text2};
`;

const TextModify = styled.span`
  font-weight: 600;
  color: ${props => props.theme.accent0};
`;

const BackToValidatorButton = styled(Button)`
  padding: 22px 72px;
  margin: 30px auto 0;
  width: auto;
  height: auto;

  border-radius: 6px;
  box-shadow: 0 20px 36px 0 rgba(0, 0, 0, 0.1);

  font-size: 16px;
  font-weight: 500;
  color: ${props => props.theme.text0};
`;

export function DelegateSuccess() {
  return (
    <DelegateWrapper>
      <Header>Delegate Assets</Header>
      <SuccessIconWrapper>
        <img src={successSrc} alt="" />
      </SuccessIconWrapper>
      <div>
        <Caption>Assets Delegated</Caption>
        <TextWrapper>
          You’ve successfully delegated <TextModify>2,452.00 NOM</TextModify> to{' '}
          <TextModify>Coinbase Custody</TextModify> validator. You will receive{' '}
          <TextModify>0.3%</TextModify> yield
        </TextWrapper>
        <Link to=".." style={{ textDecoration: 'none' }}>
          <BackToValidatorButton>Back to validator</BackToValidatorButton>
        </Link>
      </div>
    </DelegateWrapper>
  );
}
